<template>
  <div class="m-3 record-list">
    <h1>Записи</h1>

    <div class="row">
      <b-input-group prepend="Форма" class="col-md-6 pl-0">
        <b-form-select
          v-model="filter.form.selected"
          :options="filter.form.options"
          @change="get_record_list"
        ></b-form-select>
      </b-input-group>
      <b-input-group prepend="Пользователь" class="col-md-6 pr-0">
        <b-form-select
          v-model="filter.user.selected"
          :options="filter.user.options"
          @change="get_record_list"
        ></b-form-select>
      </b-input-group>
    </div>

    <table class="table table-hover">
      <thead>
        <tr>
          <th>Название формы</th>
          <th>Версия формы</th>
          <th>Пользователь</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="record in records" :key="record.id">
          <td>{{ record.version.form.title }}</td>
          <td>{{ record.version.version }}</td>
          <td>
            {{ record.user.profile.first_name }}
            {{ record.user.profile.last_name }}
          </td>
          <td class="text-right">
            <b-button variant="primary" @click="show_record(record)">
              Просмотр
            </b-button>
            <b-button variant="primary" @click="edit_record(record)">
              Редактировать
            </b-button>
            <b-button variant="danger" @click="delete_record(record)">
              Удалить
            </b-button>
          </td>
        </tr>
        <tr v-if="isEmpty">
          <td colspan="3">Список записей пуст</td>
        </tr>
      </tbody>
    </table>

    <b-modal size="xl" ref="modal-show-form" title="Форма" hide-footer>
      <form-builder
        type="readonly"
        :form="formData"
        v-model="formValues"
        ref="PreviewForm"
      ></form-builder>
      <b-button @click="$refs['modal-show-form'].hide()">Закрыть</b-button>
    </b-modal>

    <b-modal size="xl" ref="modal-edit-form" title="Форма" hide-footer>
      <form-builder
        type="gui"
        :form="formData"
        v-model="formValues"
        ref="UpdatedForm"
      ></form-builder>
      <b-button @click="$refs['modal-edit-form'].hide()">Отмена</b-button>
      <b-button variant="primary" @click="save_record">Сохранить</b-button>
    </b-modal>
  </div>
</template>

<script>
export default {
  data: () => ({
    records: [],
    isEmpty: false,
    formData: {},
    formValues: {},
    selected_record: '',
    filter: {
      form: { selected: null, options: [] },
      user: { selected: null, options: [] }
    }
  }),
  methods: {
    get_record_list() {
      var pageLoader = Vue.$loading.show();
      axios
        .post('/api/get_record_list/', {
          user: this.filter.user.selected,
          form: this.filter.form.selected
        })
        .then(response => {
          this.records = response.data.list;
          this.isEmpty = _.isEmpty(this.records);

          if (!this.isEmpty) {
            if (!_.isEmpty(response.data.filter.form)) {
              this.filter.form.options = _.union(
                [{ value: null, text: 'Все значения' }],
                response.data.filter.form
              );
            }
            if (!_.isEmpty(response.data.filter.user)) {
              this.filter.user.options = _.union(
                [{ value: null, text: 'Все значения' }],
                response.data.filter.user
              );
            }
          }
        })
        .catch(error => {
          //console.log(error);
        })
        .finally(() => pageLoader.hide());
    },
    show_record(record) {
      this.selected_record = record.id;
      this.formData = JSON.parse(record.version.data);
      this.formValues = JSON.parse(record.data);
      this.$refs['modal-show-form'].show();
    },
    edit_record(record) {
      this.selected_record = record.id;
      this.formData = JSON.parse(record.version.data);
      this.formValues = JSON.parse(record.data);
      this.$refs['modal-edit-form'].show();
    },
    save_record() {
      var pageLoader = Vue.$loading.show();
      axios
        .post('/api/edit_record/' + this.selected_record, {
          values: JSON.stringify(this.$refs.UpdatedForm.getValue())
        })
        .then(response => {
          if (response.data.result) {
            SethPhatToaster.success(response.data.msg);
            this.$refs['modal-edit-form'].hide();
            this.selected_form = 0;
            this.get_record_list();
          } else {
            SethPhatToaster.error(response.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
          SethPhatToaster.error('Что-то пошло не так');
        })
        .finally(() => pageLoader.hide());
    },
    delete_record(record) {
      if (confirm('Вы уверены что хотите удалить запись?')) {
        var pageLoader = Vue.$loading.show();
        axios
          .delete('/api/delete_record/' + record.id)
          .then(response => {
            this.get_record_list();
            if (response.data.result) {
              SethPhatToaster.success(response.data.msg);
            } else {
              SethPhatToaster.error(response.data.msg);
            }
          })
          .catch(error => {
            //console.log(error);
          })
          .finally(() => pageLoader.hide());
      }
    }
  },
  created() {
    this.get_record_list();
  }
};
</script>

<style scoped lang="scss">
  .record-list {
    .row {
      margin: 0px;
    }
  }
</style>
